import { Button, utility } from '@phi/components';
import { rem } from '@phi/util/css';
import { defineComponent, h } from 'vue';

export const CookieConsentModal = defineComponent({
    props: {
        shouldAsk: {
            type: Boolean,
            required: true,
        },
    },

    emits: {
        'update:consent': (x: boolean) => true,
    },

    setup(props, { emit }) {
        return () => h('aside',
            {
                class: {
                    [utility.hidden]: !props.shouldAsk,
                    [utility.fixed]: true,
                    [utility.z_maximum]: true,
                    [utility.bg_dgrey3]: true,
                    [utility.white_bg_lgrey]: true,
                    [utility.p_3]: true,
                    [utility.round]: true,
                    [utility.animation_duration_normal]: true,
                    [utility.animation_delay_5s]: true,
                    [utility.animation_fill_forwards]: true,
                    [utility.animation_popin]: true,
                    [utility.opaque]: true,
                    [utility.scaled_down]: true,
                    [utility.invisible]: true,
                },
                style: {
                    bottom: rem(1),
                    right: rem(1),
                    maxWidth: rem(30),
                },
            },
            [
                h('div', [
                    `We use cookies to deliver and maintain our services,
                    protect against fraud, and measure user engagement
                    with new features to enhance the quality of our services. `,
                    h('a', {
                        class: utility.no_break_word,
                        href: 'https://phi3d.com/privacy-policy',
                        target: '_blank'
                    }, 'Learn more'),
                ]),
                h('div', {
                    class: [
                        utility.flex,
                        utility.pt_3,
                        utility.gap_3,
                    ],
                }, [
                    h(Button, {
                        variant: 'primary',
                        onClick: () => emit('update:consent', true)
                    }, () => 'Allow all'),
                    h(Button, {
                        onClick: () => emit('update:consent', false)
                    }, () => 'Necessary only'),
                ])
            ]
        );
    },
});
